import React,{useEffect,useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import Menu from '../../icons/Menu';
import axios from 'axios';
import Tabmenu from '../tabmenu/Tabmenu';
import SimpleMsg from '../chatItems/simpleMsg';
import Symptoms from '../chatItems/symptoms';
import Multiselect from '../chatItems/multiselect';
import ChoiceMsg from '../chatItems/choiceMsg';
import SimpleMsgRight from '../chatItems/simpleMsgRight';
import { symtomChat } from '../../lib/api';
export default function CheckSymptoms() {
  const bottomRef = useRef(null);
  const  [chat,setChat]= useState('');
  const  [process,setprocess]= useState('stop');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [filter,setFilter] = useState({
    "model": "string",
    "messages": [
      {
        "role": "system",
        "content": "You are a helpful doctor assistant. You need to ask necessary questions to get clarification from the patients. Wish the patient if necessary. If you need clarifcation ask clasrification questions"
      }
       
    ],
    "temperature": 0.95,
    "top_p": 0.9,
    "n": 1,
    "max_tokens": 512,
    "stream": true
  })
  const [textStream, setTextStream] = useState("ert");
  const makeChat = async () => {
    setprocess('play')
    let data = filter;
    data.messages = [...data.messages,
      {
          "role": "user",
          "content": chat
        }]
        console.log(data)
        setFilter(data)
        setCurrentTime(new Date());
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth" // Optional: Smooth scrolling animation
        });
    axios({
      method: 'post',
      url: 'https://mcd-data-api.myprognosis.ai/api/v1/symptoms/completions',
      data: {
       ...data
      },
      responseType: 'stream' // Set the response type to 'stream' for streaming data
    })
    .then((response) => {
      // Handle the streaming response
      console.log(response.data)
      console.log('response.data')
      const lines = response.data.split("\n");
      console.log(lines)
      const parsedLines = lines.map(function(item) {
            item =  item.replace("data: ", "");
            item = item.replace(/\?/g, '? \n');
            item = item.replace(/(?<!\d)\.(?!\d)/g, '. \n');
          return item.replace(/(?<!\d)\.(?!\d)/g, '. \n');
        });
        let resultString = parsedLines.join(' ');
        data.messages = [...data.messages,
          {
              "role": "assistant",
              "content": resultString
            }]
            setFilter(data);
            console.log(filter)
            setCurrentTime(new Date());
            setprocess('stop')
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: "smooth" // Optional: Smooth scrolling animation
            });
      // setTextStream(parsedLines); // Set the streaming data to the state variable
    })
    .catch((error) => {
      console.error("Error fetching video stream:", error);
      setprocess('stop')
    });
   
  }
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Call your function here
      console.log("Enter key pressed! Calling a function...");
      makeChat();
      // You can pass the inputValue to your function if needed: yourFunction(inputValue);
    }
  };

  useEffect(() => {
    
  }, [filter]);
  return (
    <>
      <div className=" bg-white min-h-screen">
        <div className='flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white '>
          <div>
          <Link to="/Dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            </Link>
          </div>
          <div className='pl-2 flex-1 mt-0.5'>
            <h4 className='font-semibold text-sm'>Check Symptoms</h4>
          </div> 
          <div><button className='bg-white pl-2 h-7 w-10 rounded-full'><Menu height={17}/></button></div>
        </div>
        <div className='h-20'></div>
        <div className=' justify-between p-4 pt-12 pb-32'>
           <SimpleMsg msg={'Which symptoms is bothering you the most?'} img={'../../../logoico.png'}/> 
         {/* <SimpleMsgRight msg={'Hypertension, Diabetes, Anxiety'} img={'../../../images/male.svg'}/> 
          <SimpleMsg msg={'Are these all of the symptom(s) that are bothering you the most currently?'} img={'../../../logoico.png'}/> 
          <SimpleMsgRight msg={'Hypertension, Diabetes, Anxiety'} img={'../../../images/male.svg'}/>  */}
          {filter.messages.map((i,j)=>(<>
            {i.role=='assistant'&&             <SimpleMsg msg={i.content} img={'../../../logoico.png'}/> }
            {i.role=='user'&&             <SimpleMsgRight msg={i.content} img={'../../../logoico.png'}/> }
          </>))}
          {process=='stop'?'': <img src={'../../../images/chat-typing.gif'} className='h-auto w-8'/> }
          
        </div>
      </div>





      <div className="bg-slate-100 h-16 fixed bottom-0  max-w   w-full text-xs ">
        <div className='flex'>
          {/* <button className='p-2 text-2xl'>+</button> */}
          <div className='flex-1'>
            <input className='w-full px-6 h-16 bg-slate-100' placeholder='Write here...' type="text" onChange={(e)=>setChat(e.target.value)} onKeyPress={handleKeyPress}/>
          </div>
          {chat==''?
          <button className='text-center rounded-3xl bg-green-500 p-3 w-12 h-12 hover:bg-green-500 m-1 text-primary'>
            {/* <img src="../../../images/micicon.svg" className="h-6 w-6"/> */}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="white" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
            </svg>
          </button>
          :
          <button className='text-center rounded-3xl bg-g p-3 w-12 h-12 hover:bg-green-700 m-1 text-primary text-white' onClick={()=>makeChat()}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="white" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
            </svg>

          </button>          
          }
        </div>
      
        
      </div>
      <div className='h-16'></div>  <div ref={bottomRef} />
      {/* <Tabmenu /> */}
    </>
  );
}